import { SchoolDetailInstructorValidateType } from '../../type/Instructor/SchoolDetailInstructorNewValidate.type';

export const schoolDetailInstructorValidateInitial: SchoolDetailInstructorValidateType = {
    name: false, // 名前
    description: true, // 説明
}